export default __webpack_public_path__ + "static/logo-e121ad27c48238cb721f696b194c4755.webp";